import React from 'react';
import ReactTable from 'react-table';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import '../../styles/core.scss';
import css from './students-table.scss';
import CheckBox from '../../components/checkbox/checkbox';
import EditableTextBox from '../../components/editable-text-box/editable-text-box';
import SvgIcon from '../../components/svg-icon/svg-icon';
import StudentEmptyList from '../../components/student-empty-list/student-empty-list';
import Text from './student-table-text';


const StudentsTable = ({ studentList, studentSum, checkClick, passwordUpdate, passwordRevertNoticer }) => {
    const allCheck = function allCheck() {
        if (typeof checkClick === 'function') {
            const selectedInfo = { checkAll: true, studentSum, toWatch: studentList };
            checkClick(selectedInfo);
        }
    };

    const singleCheck = function singleCheck(student) {
        if (typeof checkClick === 'function') {
            const selectedInfo = { studentSum, toWatch: student };
            checkClick(selectedInfo);
        }
    };

    const populatePassword = function populatePassword(text, holder, student) {
        student = (holder) || student;
        if (typeof passwordUpdate === 'function') {
            passwordUpdate({ newPassword: text, student });
        }
    };

    const passwordEditor = cellInfo => (
        <EditableTextBox
            textData={cellInfo.value}
            holderData={cellInfo}
            receiveCharsUpdate={(text, holder) => {
                populatePassword(text, (holder || {}).original, cellInfo.original);
            }}
            passwordRevertNoticer={passwordRevertNoticer} />
    );

    const cellDiv = row => (
        <div className={`${css.cell} ${row.original.selected ? css.selected : ''}`}>{row.value}</div>
    );

    const headerLabel = (label, icon) => (
        <div className={css.header}>
            <span>{label}{icon ? (<SvgIcon type={icon} />) : ''}</span>
        </div>
    );
    const columns = [{
        Header: () => (
            <div className={`${css['cell-check']}`} >
                <CheckBox data={{ type: 'plain', selected: studentSum.allSelected }} callback={() => allCheck()} />
            </div>
        ),
        accessor: 'selected',
        Cell: row => (
            <div className={`${css['cell-check']}`}>
                <CheckBox
                    data={{ type: 'plain', selected: row.value }}
                    callback={() => singleCheck(row.original)} />
            </div>
        ),
        maxWidth: 50,
        resizable: false
    },
    {
        Header: () => headerLabel(Text.firstName, 'sort'),
        accessor: 'firstName',
        Cell: cellDiv
    },
    {
        Header: () => headerLabel(Text.surname, 'sort'),
        accessor: 'lastName',
        Cell: cellDiv
    },
    {
        Header: () => headerLabel(Text.username),
        accessor: 'username',
        Cell: cellDiv,
        sortable: false
    },
    {
        Header: () => headerLabel(Text.password),
        accessor: 'password',
        Cell: passwordEditor,
        sortable: false
    },
    {
        Header: () => headerLabel(Text.group),
        accessor: 'groupName',
        Cell: cellDiv,
        sortable: false
    },
    {
        Header: () => headerLabel(Text.course),
        accessor: 'courseName',
        Cell: cellDiv,
        sortable: false
    }
    ]
    ;

    let contentDom;

    const rowHandler = (state, rowInfo) => {
        const override = {};
        if (rowInfo.row.selected) {
            override.className = 'box brand-light dark-5';
        }
        return override;
    };
    if (studentList && studentList.length > 0) {
        contentDom = (
            <ReactTable
                data={studentList}
                columns={columns}
                className="-striped -highlight"
                showPaginationBottom={studentList > 1000}
                minRows={0}
                pageSize={1000}
                getTrGroupProps={rowHandler}
                getTheadProps={() => ({ className: 'box grey-light' })}
            />
        );
    } else {
        contentDom = (<StudentEmptyList type={Text.noStudents} wholeClass={false} />);
    }

    return (
        <div className={css['students-table-panel']} >
            {contentDom}
        </div>
    );
};

StudentsTable.propTypes = {
    studentList: PropTypes.array,
    studentSum: PropTypes.object,
    checkClick: PropTypes.func,
    passwordUpdate: PropTypes.func,
    passwordRevertNoticer: PropTypes.object
};

export default styleable(css)(StudentsTable);



// WEBPACK FOOTER //
// ./components/students-table/students-table.js